import React from "react";

import Slider from "./Slider";

function Testimonials() {
  return (
    <div className="max-w-7xl mx-auto mt-20">
      <h1 className="font-semibold font-josefin text-6xl text-mix-400 text-center pt-20 pb-12 px-4">
        Testimonials
      </h1>
      <Slider />
    </div>
  );
}

export default Testimonials;